import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { EditCommentDialogContent } from './EditCommentDialogContent'

interface IProps {
  isShowDialog: boolean

  currentEditComment: string
  onApply: (value: string) => Promise<void>
  onCancel: () => void
}

export const EditCommentDialog = ({
  isShowDialog,

  currentEditComment,
  onApply,
  onCancel,
}: IProps) => {
  const contentProps = useMemo(() => {
    return { currentEditComment, onApply, onCancel }
  }, [currentEditComment, onApply, onCancel])

  return (
    <ModalDialog
      size={'md'}
      show={isShowDialog}
      content={EditCommentDialogContent}
      contentProps={contentProps}
      onClose={onCancel}
    />
  )
}
